import Navbar from "../components/Navbar";
import ServiceHero from "../components/ServiceHero";
import WhyChooseUs from "../components/WhyChooseUs";
import CTA from "../components/CTA";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";

const SoftwareDevelopment = () => {
  return (
    <>
      <Navbar />

      <ServiceHero
        title="Software Development"
        subtitle="Custom software, SaaS platforms, business automation and enterprise solutions tailored to your workflow."
      />

      <WhyChooseUs />

      <CTA />

      <Footer />

      <WhatsAppButton />
    </>
  );
};

export default SoftwareDevelopment;